import React, { useEffect, useState } from "react";
// Components
import DateCard from "../date-card/DateCard";
import styles from "./countdown.module.css";
import { useLanguage } from "../../utils/language";

function Countdown({ targetDate }) {
  const { getTranslation, langId } = useLanguage();
  const [day, setDay] = useState("-");
  const [hour, setHour] = useState("-");
  const [minute, setMinute] = useState("-");
  const [second, setSecond] = useState("-");
  // Countdown Title to remain one row
  const [titleMinWidth, setTitleMinWidth] = useState();

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const timeDifference = targetDate - now;

      if (timeDifference > 0) {
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        setDay(days);
        setHour(hours);
        setMinute(minutes);
        setSecond(seconds);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  useEffect(() => {
    if (langId === "en") setTitleMinWidth(styles.enTitleMinWidth);
    else if (langId === "cn") setTitleMinWidth(styles.cnTitleMinWidth);
  }, [langId]);

  return (
    <section className={styles.container}>
      <h2 className="sectionTitle">{getTranslation("countdown_title")}</h2>
      <div className={styles.dateContainer}>
        <DateCard
          title={getTranslation("countdown_day")}
          content={day}
          className={titleMinWidth}
        />
        <DateCard
          title={getTranslation("countdown_hour")}
          content={hour}
          className={titleMinWidth}
        />
        <DateCard
          title={getTranslation("countdown_minute")}
          content={minute}
          className={titleMinWidth}
        />
        <DateCard
          title={getTranslation("countdown_second")}
          content={second}
          className={titleMinWidth}
        />
      </div>
    </section>
  );
}

export default Countdown;
